(ns motorsaif.web.events
  (:require
   [goog.dom :as gdom]
   [taoensso.encore :as encore]
   [motorsaif.shared.interceptors :as ic]
   [goog.events.EventType :as events.EventType]
   [goog.net.Cookies :as gcookies]
   [goog.string :refer [format]]
   [meta-merge.core :as mm]
   [motorsaif.web.admin-events]
   [motorsaif.data-utils :as du]
   [motorsaif.web.fx]
   [motorsaif.log :as log]
   [motorsaif.version :as ver :refer [version]]
   [motorsaif.web.pwa :as pwa]
   [motorsaif.web.subs :as subs]
   [motorsaif.time :as time]
   [motorsaif.shared.events :as shared-events :refer
    [merge-db-id-coll
     vec->db-id-map]]
   [motorsaif.utils :as utils]
   [re-frame.core :as rf]
   [reitit.frontend.controllers :as rfc]
   [motorsaif.sente :as sente]))

(def cookies (gcookies/getInstance))

(rf/reg-event-fx :toast-persuasions
  (fn [{:keys [db] :as cofx} [_ form-key data]]
    (let [push-id false
          can-push? pwa/can-push?
          logged-in? (:user db)
          can-ask? (when-let [?ask-again (.get cookies "ask-again-notifications")]
                     (time/before? (time/normalize-time ?ask-again)
                                   (time/date)))
          ret (-> []
                  (cond-> (and logged-in?
                               (not push-id)
                               can-push?
                               can-ask?)
                    (conj [:toast {:type "warn"
                                   :auto-close false
                                   :id :enable-alerts
                                   :draggable false
                                   :position "bottom-center"
                                   :close-on-click false
                                   :title "Get Notified"
                                   :buttons [{:title "Enable Alerts"
                                              :class "primary"
                                              :click (fn [close]
                                                       (pwa/ask-enable-notifications)
                                                       (close))}
                                             {:title "Not now"
                                              :click (fn [close]
                                                       (.set cookies "ask-again-notifications"
                                                             (time/stamp-plus :days 5))
                                                       (close))}]
                                   :message "To see incoming messages, please enable alerts"}])))]

      {:fx ret})))

(rf/reg-event-fx :check-version
  (fn [_ [_ server-version]]
    (log/debug [:client-version version
                :server-version server-version])
    (let [ret (-> []
                  (cond-> (not= version server-version)
                    (conj
                     [:toast {:type "warn"
                              :auto-close false
                              :id :version
                              :opts  {:closeButton false}
                              :draggable false
                              :position "bottom-center"
                              :close-on-click false
                              :title "Update Required"
                              :buttons [{:title "Update"
                                         :class "primary"
                                         :click (fn [close]
                                                  (js/window.location.reload))}]
                              :message "MotorSaif has a new version ready for you."}])))]
      {:fx ret})))

(comment
  (rf/dispatch [:toast {:type "warn"
                        :auto-close false
                        ;; :id :nable-reload
                        :opts  {:closeButton false}
                        :draggable false
                        :position "bottom-center"
                        :close-on-click false
                        :title "Update Required"
                        :buttons [{:title "Update"
                                   :class "primary"
                                   :click (fn [close]
                                            (js/window.location.reload))}]
                        :message "MotorSaif has a new version ready for you."}])

  (rf/dispatch [:toast {:type "warn"
                        :auto-close false
                        :id :enable-alerts
                        :opts  {:closeButton false}
                        :draggable false
                        :position "bottom-center"
                        :close-on-click false
                        :title "Get Notified"
                        :buttons [{:title "Enable Alerts"
                                   :class "primary"
                                   :click (fn [close]
                                            (pwa/ask-enable-notifications)
                                            (close))}
                                  {:title "Not now"
                                   :click (fn [close]
                                            (.set cookies "ask-again-notifications"
                                                  (time/stamp-plus :days 5))
                                            (close))}]
                        :message "To see incoming messages, please enable alerts"}])
  (rf/dispatch [:toast-persuasions]))

;; Add afn to fire off after for a single page change
(rf/reg-event-db :page/on-change-once
  (fn [db [_ afn]]
    (update db :page/on-change-queue (fnil #(conj % afn) []))))
;; (:page/on-change-queue @re-frame.db/app-db)

(rf/reg-event-db :page/consume-change-queue
  (fn [db [_ match]]
    (doseq [afn (:page/on-change-queue db)]
      (afn match))
    (dissoc db :page/on-change-queue)))

(rf/reg-event-db :reitit/navigate
  (fn [db [_ match]]
    (let [old-match (:route/data db)
          new-match (assoc match :controllers
                           (rfc/apply-controllers (:controllers old-match) match))]
      (rf/dispatch [:page/consume-change-queue match])
      (set! (.-className js/document.body) (name (-> new-match :data :name)))
      (-> db
          (assoc :route/data new-match)
          (assoc :route/last-data old-match)))))

(rf/reg-event-fx :page/init-home
  (fn [_ _]
    {:dispatch-n
     [[:fetch-requests]]}))

(rf/reg-event-db :clear-modal
  (fn [db _]
    (dissoc db :modal)))

(rf/reg-event-db :set-modal
  (fn [db [_ modal]]
    (assoc db :modal modal)))

(rf/reg-event-fx :bootstrap-data
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx _]
    (let [{{:keys [query-params]} :route/data} (:db cofx)]
      {:ajax (-> {:type    :GET
                  :id      :bootstrap-data
                  :url "/api/bootstrap-data"
                  :handler [:set-bootstrap-data]}
                 (cond-> (seq query-params)
                   (assoc :params query-params)))})))

(rf/reg-event-fx :resync-bootstrap-data
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx _]
    (let [{{:keys [query-params]} :route/data} (:db cofx)]
      {:ajax (-> {:type    :GET
                  :id      :resync-bootstrap-data
                  :url "/api/bootstrap-data"
                  :handler [:set-bootstrap-data]}
                 (cond-> (seq query-params)
                   (assoc :params query-params)))})))

(rf/reg-event-fx :logout
  (fn [cofx [_ form-key data]]
    {:ajax {:type :POST
            :url  "/api/account/logout"
            :handler
            (fn [{:keys [success] :as res}]
              (when success
                (rf/dispatch
                 [:toast {:type    "success"
                          :message "Logged out"}])
                ;; (rf/dispatch [:assoc-data :user nil])
                (rf/dispatch [:common/navigate! :home])
                (rf/dispatch [:assoc-data :current-owner-id nil])
                (rf/dispatch [:assoc-data :user nil])))}}))

(rf/reg-event-fx :common/navigate!
  ;; [fx/ensure-verified]
  (fn [_ [_ url-key params query]]
    {:common/navigate-fx! [url-key params query]}))

(rf/reg-event-fx :common/replace-state!
  (fn [_ [_ url-key params query]]
    {:common/replace-url-state! [url-key params query]}))


(rf/reg-event-fx :swap-current-owner
  (fn [_ [_ id]]
    {:ajax {:type   :POST
            :id     :swap-current-owner
            :params {:owner-id id}
            :url    "/api/account/swap-owner"
            :handler
            (fn [{:keys [success] :as res}]
              (if success
                ;; TODO should ensure we completely flush things tied to previous owner context
                ;; (rf/dispatch-sync [:bootstrap-data])
                (js/window.location.reload)
                (rf/dispatch [:toast {:type    "error"
                                      :message "Problem changing accounts"}])))}}))


(def ^:private vsm (goog.dom.ViewportSizeMonitor.))

(let [resize-fn #(let [viewport (gdom/getViewportSize)
                       h (.-height viewport)
                       w (.-width viewport)
                       breakpoint (condp < w
                                    1200 [:desktop :xl]
                                    1025 [:desktop :l]
                                    768 [:desktop]
                                    480 [:tablet]
                                    325 [:mobile]
                                    [:mobile :xs])]
                   (rf/dispatch [:assoc-data :vsm {:width w
                                                   :height h
                                                   :breakpoint breakpoint}]))]

  (utils/register-event :resize vsm events.EventType/RESIZE resize-fn)
  (resize-fn))

(rf/reg-event-fx :login
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ {:user/keys [auth-identity password master-nonce] :as data}]]
    (log/info [:user data master-nonce])
    {:ajax
     {:type :POST
      :url     "/api/account/login"
      :params {:data data}
      :id :login
      :handler
      (fn [{:keys [data] :as res}]
        (let [{:keys [status user email]} data
              {:keys [ran? next-run-at]} email]
          (condp = status
            :sent-login-link
            (if ran?
              (rf/dispatch [:toast {
                                    :type "error"
                                    :auto-close 2000
                                    :message "Wrong password, but a login link has been sent to your email."}])
              (rf/dispatch [:toast {:type "error"
                                    :auto-close 2000
                                    :message "Wrong password."}]))

            :login (do
                     (rf/dispatch-sync [:common/navigate! :feed])
                     (js/window.location.reload)
                     ;; NOTE janky
                     ;; (rf/dispatch [:assoc-data :user user])
                     )
            :no-account
            (rf/dispatch [:toast {:type "error"
                                  :message "Wrong user name or password."}])
            :failed-auth
            (rf/dispatch [:toast {:type "error"
                                  :message "User with that account already exists."}])
            :else
            (rf/dispatch [:toast {:type "error"
                                  :message (format "Failed to signup %s: " ex-message)}]))))
      :error-handler (fn [res]
                       (println "ERRO"))}}))

(comment
  (rf/dispatch [:login {:user/master-nonce "jqiflyhudzldovph4khgcypq" }]))
(comment
  (rf/dispatch [:fetch-user-touches]))

(rf/reg-event-db :register-webpush
  #_[ic/trace-fetch-status
     ic/prevent-duplicate-requests]
  (fn [db [_ sub]]
    ;; If the client ID already matches the sub,
    ;; just set the state to :subbed
    ;; If not, on ajax success do above

    (let [endpoint (when sub (.-endpoint sub))
          exists? (some #(= (get-in % [:client/sub "endpoint"]) endpoint) (:clients db))
          sub->str (js/JSON.stringify sub)]

      (rf/dispatch [:assoc-data [:pwa :sub] sub])

      (if exists?
        (assoc-in db [:pwa :push-state] :subbed)
        (do
          (rf/dispatch [:do-ajax
                        {:type :POST
                         :id   :webpush
                         :url  "/api/account/push"
                         :params {:data sub->str
                                  :type :web}
                         :handler
                         (fn [{:keys [success data] :as ret}]
                           ;; (log/info [:webpush-ret ret])
                           (when success
                             (rf/dispatch [:assoc-data :clients data])
                             (rf/dispatch [:assoc-data [:pwa :push-state] :subbed])))}])
          (assoc-in db [:pwa :push-state] :pending))))))

(comment
  (:clients @re-frame.db/app-db))

(rf/reg-event-fx :update-feed-filters
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [cofx [_ id]]
    {:ajax {:type :DELETE
            :id   :delete-webpush
            :url  "/api/update-feed-filters"
            :params {:client-id id}
            :handler
            (fn [{:keys [success data] :as ret}]
              (log/info [:webpush-ret ret])
              (when success
                (rf/dispatch [:assoc-data :clients data])))}}))

(rf/reg-event-fx :update-request-status
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ request-id status]]
    {:ajax {:type :PUT
            :id   :urs
            :url  "/api/requests/status"
            :params {:data {:request {:db/id request-id
                                      :request/status status}}}
            :handler
            (fn [{:keys [success]}]
              (when success
                (rf/dispatch [:common/navigate! :home])
                (js/setTimeout (fn []
                                 (rf/dispatch-sync [:reset-requests])
                                 (condp = status
                                   :resolved (rf/dispatch [:toast {:type "success"
                                                                   :message "Request resolved"}])
                                   :expired
                                   (rf/dispatch [:toast {:type "success"
                                                         :message "Request expired"}])

                                   :deleted
                                   (rf/dispatch [:toast {:type "success"
                                                         :message "Request deleted"}])

                                   :active
                                   (rf/dispatch [:toast {:type "success"
                                                         :message "Request reactivated"}]))
                                 )
                               500)
                #_(js/window.location.reload)))}}))

(rf/reg-event-fx :unverified-user
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ last-route]]
    ;; We display modal and check backend once more to see whether user has been verified or not. If they're verified, modal is cleared.
    {:ajax {:type :GET
            :id      :user-verified
            :url "/api/bootstrap-data"
            :handler (fn [res]
                       (rf/dispatch-sync [:assoc-data :user (:user res)])
                       (when (= (get-in res [:user :user/status :db/ident]) :verified)
                         (rf/dispatch-sync [:assoc-data :route/data last-route])))}
     :fx [
          ;; [:dispatch [:common/navigate! :feed]]
          [:dispatch [:common/navigate! :profile]]
          [:dispatch-later {:ms 100 :dispatch [:set-modal {:modal-key :verify-email}]}]]}))

(rf/reg-event-fx :ensure-user
  (fn [cofx _]
    (let [db (:db cofx)
          user? (get-in db [:user])]
      (if user?
        {}
        {:fx [[:dispatch [:common/navigate! :sign-up]]]}))))

(comment
  (rf/dispatch [:common/navigate! :verify-code])
  (rf/dispatch [:common/navigate! :login])
  (rf/dispatch [:verify-email
                {:email "naomarik@gmail.com"
                 :context :new-user}])
  (rf/dispatch [:verify-email "oamr@test.com"]))

(rf/reg-event-db :set-locale
  (fn [db [_ locale]]
    (assert (#{:ar :en :ur} locale))
    (.set cookies "locale" (name locale))
    ;; (i18n/set-tr-fn! @i18n/*dict
    ;;                  (rf/subscribe [:locale]))
    (assoc db :locale locale)))


(rf/reg-event-fx :login-google
  [ic/trace-fetch-status
   ic/prevent-duplicate-requests]
  (fn [_ [_ client-code]]
    {:ajax (-> {:type    :POST
                :id      :oauth/google
                :params {:client-code client-code}
                :url "/api/oauth/google"
                :handler (fn [{:keys [success state user] :as ret}]
                           (def zhe ret)
                           (when success
                             (rf/dispatch-sync [:common/navigate! :feed])
                             (js/window.location.reload)))})}))

(rf/reg-event-fx :message/edit
  (fn [cofx [_ id body]]
    (let [{:keys [form input-ref]} (get-in cofx [:db :forms :message-form])
          {:keys [set-val]} form]
      (set! ^js (.-current.textContent input-ref) body)
      (set-val [:message] #(merge %
                                  {:db/id id
                                   :message/body body})))))

(rf/reg-event-fx :message/edit-cancel
  (fn [cofx [_ id]]
    (let [{:keys [form input-ref]} (get-in cofx [:db :forms :message-form])
          {:keys [set-val]} form]
      (set! ^js (.-current.textContent input-ref) "")
      (set-val [:message] #(dissoc % :db/id :message/body)))))

;; =============================================================================
;; THEME EVENTS
;; =============================================================================

(defn set-theme! [theme-name]
  (let [doc-el js/document.documentElement
        current-classes (-> doc-el .-classList .toString (clojure.string/split #" "))
        theme-classes (filter #(clojure.string/starts-with? % "theme-") current-classes)]
    
    ;; Remove any existing theme classes
    (doseq [theme-class theme-classes]
      (.remove (.-classList doc-el) theme-class))
    ;; Add the new theme class
    (.add (.-classList doc-el) theme-name)
    ;; Save to localStorage
    (js/localStorage.setItem "theme" theme-name)))

(rf/reg-event-fx :theme/set
  (fn [{:keys [db]} [_ theme-name]]
    (set-theme! theme-name)
    {:db (assoc db :current-theme theme-name)}))

(defn set-font-size! [size]
  "Set font size on HTML root element and save to localStorage"
  (let [doc-el js/document.documentElement
        size-map {"small" "92%" "medium" "100%" "large" "108%"}
        percentage (get size-map size "100%")]
    (set! (.. doc-el -style -fontSize) percentage)
    (js/localStorage.setItem "font-size" size)))

(rf/reg-event-fx :font-size/set
  (fn [{:keys [db]} [_ size]]
    (set-font-size! size)
    {:db (assoc db :current-font-size size)}))
